var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreditCard = function SvgCreditCard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 20H44V38C44 40.2091 42.2091 42 40 42H8C5.79086 42 4 40.2091 4 38V20Z",
    fill: "#7B8096"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 32,
    width: 8,
    height: 4,
    fill: "#ECEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 16L4 16L4 10C4 7.79086 5.79086 6 8 6L40 6C42.2091 6 44 7.79086 44 10L44 16Z",
    fill: "#7B8096"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCard);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM0OV80MjUpIj4KPHBhdGggZD0iTTQgMjBINDRWMzhDNDQgNDAuMjA5MSA0Mi4yMDkxIDQyIDQwIDQySDhDNS43OTA4NiA0MiA0IDQwLjIwOTEgNCAzOFYyMFoiIGZpbGw9IiM3QjgwOTYiLz4KPHJlY3QgeD0iMzAiIHk9IjMyIiB3aWR0aD0iOCIgaGVpZ2h0PSI0IiBmaWxsPSIjRUNFQkZGIi8+CjxwYXRoIGQ9Ik00NCAxNkw0IDE2TDQgMTBDNCA3Ljc5MDg2IDUuNzkwODYgNiA4IDZMNDAgNkM0Mi4yMDkxIDYgNDQgNy43OTA4NiA0NCAxMEw0NCAxNloiIGZpbGw9IiM3QjgwOTYiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zNDlfNDI1Ij4KPHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";